import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Divisions from "@/pages/Divisions";
import Portfolio from "@/pages/Portfolio";
import Partner from "@/pages/Partner";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

function Shell() {
  const loc = useLocation();
  // Detect OAuth callback via URL fragment (do NOT rely on useEffect timing)
  if (loc.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/divisions" element={<Divisions />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}
